import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

/**
 * Helper function to determine if any item data (product name, product image, product size or price) in the
 * fetch list of eligible RTK items is missing from the response.
 *
 * @param {Object[]} orders List of orders containing items eligible for RTK
 * @param {Object[]} orders.rentToKeepItems List of RTK-eligible items within order
 * @param {String} orders.rentToKeepItems.name
 * @param {String[]} orders.rentToKeepItems.photos
 * @param {Number} orders.rentToKeepItems.rentToKeepPrice
 * @param {Object} orders.rentToKeepItems.sizes
 * @returns {Boolean} Determines if there are missing item from list of items
 */
export const isEligibleOrderItemsMissingData = (orders) => {
  if (!orders.length) {
    return true
  }

  return orders.some(({rentToKeepItems}) => {
    if (!rentToKeepItems.length) {
      return true
    }

    return rentToKeepItems.some(({name, photos, rentToKeepPrice, sizes}) => {
      if (!name) return true
      if (!photos || !photos.length) return true
      if (isNil(rentToKeepPrice)) return true
      if (isNil(sizes) || isEmpty(sizes)) return true
      return false
    })
  })
}
